(function(algolia) {
  'use strict';
  algolia.translations = {
    searchTitle: 'Søkeordfiltrering',
    search: 'Nåværende søk',
    noCollectionFound: 'Ingen samlinger funnet',
    allProducts: 'Se alle produkter',
    matching: 'samsvarer',
    sortBy: 'Sorter etter',
    relevance: 'Relevans',
    outOf: 'tomt for',
    resultsFound: 'resultater',
    oneResultFound: '1 resultat',
    noResultFound: 'Ingen resultater funnet',
    addToCart: 'Legg i handlekurv',
    searchForProduct: 'Søk etter produkter',
    selectedFilter: 'Valgte filter',
    clearAll: 'Fjern valg',
    noPageFound: 'Ingen side funnet',
    outOfStock: 'Tomt på lager',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Ingen resultater for søk ' + render(text);
    },
    in: function() {
      return '(' + this.processingTimeMS / 1000 + 's)';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Prøv å ' +
        render(html_tags[0]) +
        'fjern alle filter' +
        render(html_tags[1]) +
        ' eller ' +
        render(html_tags[2]) +
        ' endre søkeord ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        'Viser ' +
        (this.page * this.hitsPerPage + 1) +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' av'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
